// @flow

// Utils
import createReducer from 'fc-utils/createReducer'

// InitialState
import initialState from './initialState'

// Controller
import commentsCtrl from 'hfty-ctrl-comments'

// Exports
export default createReducer(initialState, {
  ...commentsCtrl.reducers,
})
